import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroSubArreglos'
})
export class FiltroSubArreglosPipe implements PipeTransform {

  transform(value: any[], propiedadPrincipal: string, propiedadSecundaria:string, dato:string): any[] {
    let arr = []

    for(let i of value){
      for(let j of i[propiedadPrincipal]){
        if(String(j[propiedadSecundaria]) == String(dato)){
          arr.push(i)
        }
      }
    }

    return arr;
  }

}
